import { OverflowList } from '@theme/critical';
import { Component } from '@theme/component';


/**
 * A custom element that displays a colour option.
 *
 * @typedef {object} Refs
 * @property {HTMLAnchorElement} colourOptionLink - The colour option link element.
 * @property {import('slideshow').Slideshow} [slideshow] - The slideshow component.
 * @property {import('quick-add').QuickAddComponent} [quickAdd] - The quick add component.
 * @property {HTMLElement} [cardGallery] - The card gallery component.
 *
 * @extends {Component<Refs>}
 */
export class FAQS extends Component {
  requiredRefs = [];



  connectedCallback() {
    super.connectedCallback();
    const link = this.refs.colourOptionLink;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    //this.removeEventListener('click', this.navigateToProduct);
  }

}

if (!customElements.get('faq-wrap')) {
  customElements.define('faq-wrap', FAQS);
}
export class FAQSubject extends Component {
  requiredRefs = ["questions"];
    #questions= null
    #title= null

  connectedCallback() {
    super.connectedCallback();
    this.#questions=this.refs.questions
    this.#title=this.refs.subject_title
    this.#title.addEventListener('click', this.clickSubject);
    console.log("init");
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    //this.removeEventListener('click', this.navigateToProduct);
  }

   /**
   * Intercepts the click event on the subject title
   *
   * @param {Event} event
   */
  clickSubject=(event)=>{
    
    if (!(event.target instanceof Element)) return;
    this.#questions.style["--question-max-height"]=`${this.#questions.myheight()}px`;
    console.log("click",this.#questions.style["--question-max-height"]);
    this.#questions.classList.toggle("open");
    
    }

}

if (!customElements.get('faq-subject')) {
  customElements.define('faq-subject',FAQSubject);
}
export class FAQQuestions extends Component {
  requiredRefs = [];
  myheight=()=>{
    let totalHeight = 0;
    Array.from(this.children).forEach(child => {
        // Use offsetHeight for content + padding + border
        // Add margin-top and margin-bottom to get the total space taken
        const style = window.getComputedStyle(child);
        const margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        const childHeight=child.myheight?child.myheight():child.offsetHeight;
        totalHeight += child.offsetHeight + margin;
    });
    return totalHeight
  };



  connectedCallback() {
    super.connectedCallback();

  }

  disconnectedCallback() {
    super.disconnectedCallback();
    //this.removeEventListener('click', this.navigateToProduct);
  }

}

if (!customElements.get('faq-questions')) {
  customElements.define('faq-questions',FAQQuestions);
}
export class FAQQuestion extends Component {
  requiredRefs = [];
    myheight=()=>{
    let totalHeight = 0;
    Array.from(this.children).forEach(child => {
        // Use offsetHeight for content + padding + border
        // Add margin-top and margin-bottom to get the total space taken
        const style = window.getComputedStyle(child);
        const margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        const childHeight=child.myheight?child.myheight():child.offsetHeight;
        totalHeight += child.offsetHeight + margin;
    });
    return totalHeight
  };


  connectedCallback() {
    super.connectedCallback();

  }

  disconnectedCallback() {
    super.disconnectedCallback();
    //this.removeEventListener('click', this.navigateToProduct);
  }

}

if (!customElements.get('faq-question')) {
  customElements.define('faq-question',FAQQuestion);
}

export class FAQAwnser extends Component {
  requiredRefs = [];
myheight=()=>{
    let totalHeight = 0;
    Array.from(this.children).forEach(child => {
        // Use offsetHeight for content + padding + border
        // Add margin-top and margin-bottom to get the total space taken
        const style = window.getComputedStyle(child);
        const margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        const childHeight=child.myheight?child.myheight():child.offsetHeight;
        totalHeight += child.offsetHeight + margin;
    });
    return totalHeight
  };


  connectedCallback() {
    super.connectedCallback();


  }

  disconnectedCallback() {
    super.disconnectedCallback();
    //this.removeEventListener('click', this.navigateToProduct);
  }

}

if (!customElements.get('faq-awnser')) {
  customElements.define('faq-awnser',FAQAwnser);
}
